<template>
    <div class='login-container mobile' style='padding: 0 !important;'>
        <div class='contract-content' style='padding: 0'>
            <div
                    style='padding: 0'
                    v-for="(item, index) in contractList"
                    :key="index"
                >
                <div class='contract-content-info' style='padding: 0 20px 20px 20px;'>
                        <div class='contract-title-input' style='margin-bottom: 20px; margin-top: 20px; background-color: white'>
                            {{item.e_contract_title}}
                        </div>
                        <div class='contract-info-title'>수신인 정보</div>
                        <div style='display: flex'>
                            <div class='contract-info-sub-title mobile-title'>이름</div>
                            <div class='contract-info-sub-title' v-show='templateSendId > 0'>{{item.recipientName}}</div>
                        </div>
                        <div style='display: flex'>
                            <div class='contract-info-sub-title mobile-title'>연락처</div>
                            <div class='contract-info-sub-title' v-show='templateSendId > 0'>{{item.recipientPhone | phoneNumberFilter}}</div>
                        </div>
                        <div v-show='item.centerContractId > 0 && item.centerProdId > 0 && checkTicketInfo(item.ticketInfo)'>
                        <div class='contract-info-title' v-show='item.e_contract_member_type == "M"'>이용권 정보</div>
                            <div v-show='templateSendId > 0 && item.e_contract_member_type == "M"'>
                                <div v-for='(ticketInfo, index) in JSON.parse(item.ticketInfo)' :key='index' class='ticket-container'>
                                    <div class='ticket-box'>
                                        <div class='ticket-box-title'>{{ticketInfo.title}}</div>
                                        <div class='ticket-box-info'>
                                            <div style='flex: 1'>
                                                {{ticketInfo.period}}
                                            </div>
                                            <div>
                                                {{ticketInfo.price}}원
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
<!--                            <div class='contract-info-sub-title' v-show='templateSendId > 0 && item.e_contract_member_type == "M"'>{{item.ticketSendCount + "/" + item.ticketSendPrice}}</div>-->
<!--                            <div class='contract-info-sub-title' v-show='templateSendId > 0 && item.e_contract_member_type == "M"'>{{item.ticketAvailableCount}} 건</div>-->
                        </div>
                        <div class='contract-info-title'>약관</div>
                        <div style='padding: 10px 10px 0 10px' v-for='(it, i) in item.templateInfo'>
                            <div v-if='it.type == 1'>
                                <div class='contract-info-sub-title' style='display: flex'>
                                    <div style='flex: 1;'>{{it.title}}</div>
                                </div>
                                <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent' disabled>{{it.content}}</textarea>
                            </div>
                            <div v-else style='display: flex'>
<!--                                <div class='com-check' style='margin-top: 12px'>-->
<!--                                    <input-->
<!--                                        :id='`agree-check-${index}-${i}`'-->
<!--                                        class='force-opacity'-->
<!--                                        name='check-c1'-->
<!--                                        type='checkbox'-->
<!--                                        :checked='true'-->
<!--                                        disabled-->
<!--                                    />-->
<!--                                    <label :for='`agree-check-${index}-${i}`' class='agree-option' style='cursor: default'></label>-->
<!--                                </div>-->
                                <div style='flex: 1;'>
                                    <div class='contract-info-sub-title' style='display: flex'>
                                        <div style='flex: 1;'>{{it.title}}</div>
                                    </div>
                                    <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent' disabled>{{it.content}}</textarea>
                                    <div v-for='(jt, j) in it.options' style='display: flex; align-items: center; margin-top: 10px'>
                                        <div class='com-check'>
                                            <input
                                                :id='`agree-check-${index}-${i}-${j}`'
                                                class='force-opacity'
                                                name='check-c1'
                                                type='checkbox'
                                                :checked='true'
                                                disabled
                                            />
                                            <label :for='`agree-check-${index}-${i}-${j}`' class='agree-option' style='cursor: default'></label>
                                        </div>
                                        <div class='agree-option-input'>{{jt.title}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style='display: flex' v-show='templateSendId > 0'>
                            <div class='contract-info-title' style='flex: 1;'>{{item.sendTime | dateFormatFilter2}}</div>
                            <div style='width: 160px; margin-top: 40px; margin-bottom: 20px;'>
                                <div style='display: flex; align-items: center'>
                                    <div class='contract-info-person'>수신인</div>
                                    <img class='contract-info-signature mobile-sign' :class='recipientSignImageRawData == "" ? "no-image" : ""' :src='`${recipientSignImageRawData}`' />
                                </div>
                                <div style='display: flex; align-items: center; margin-top: 10px;'>
                                    <div class='contract-info-person'>발신인</div>
                                    <img class='contract-info-signature mobile-sign' :class='senderSignImageRawData == "" ? "no-image" : ""' :src='`${senderSignImageRawData}`' />
                                </div>
                            </div>
                        </div>
                    </div>
                <div style='background-color: #ffece9; color: #497895; width: 100%; height: 48px; line-height: 48px; font-size: 16px; text-align: center'>
                    {{item.templateSendStatus | getContractSendStatusStr}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { convertImgToDataURLviaCanvas } from '@/assets/js/common';
import { getSendTemplateDetail } from '@/assets/js/api';

export default {
    name: 'CheckContract',
    props: {},
    computed: {
    },
    components: {
    },
    data() {
        return {
            templateSendId: this.$route.params.id,
            contractList: [],
            recipientSignImageRawData: "",
            senderSignImageRawData: "",
        };
    },
    mounted() {
        this.uid = window.localStorage.getItem('uid');

        this.init();
    },
    methods: {
        async init() {
            Promise.all([
                this.getTemplate(),
            ]).then((response) => {
                if (response && response.length > 0) {
                    this.contractList = response[0].data;
                    if (this.contractList && this.contractList.length > 0) {
                        this.contractList.map(item => {
                            if (item.senderSignImageUrl !== "") {
                                this.senderSignImageRawData = item.senderSignImageUrl;
                                convertImgToDataURLviaCanvas(item.senderSignImageUrl, (imageRawData) => {
                                    this.senderSignImageRawData = imageRawData;
                                })
                            }
                            if (item.recipientSignImageUrl !== "") {
                                this.recipientSignImageRawData = item.recipientSignImageUrl;
                                convertImgToDataURLviaCanvas(item.recipientSignImageUrl, (imageRawData) => {
                                    this.recipientSignImageRawData = imageRawData;
                                })
                            }
                        })
                    }

                    this.autoHeightTextArea();
                }
            })
        },

        autoHeightTextArea() {
            setTimeout(() => {
                let areas = document.querySelectorAll("textarea");
                for (var i = 0; i < areas.length; i++) {
                    areas.item(i).style.height = "auto"
                    areas.item(i).style.height = areas.item(i).scrollHeight + "px"
                }
            }, 10)
        },

        async getTemplate() {
            return getSendTemplateDetail(this.templateSendId)
            // return api.get(`/admin/api/center/0/staff/0/contract/template/send/${this.templateSendId}`);
        },

        checkTicketInfo(info) {
            if (info) {
                const ticketInfo = JSON.parse(info);

                return ticketInfo && ticketInfo.length > 0
            }

            return false;
        },
    },
};
</script>
